import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Utils/NewIcon';
import { HandoverModal } from 'components/Schedule/Vacations/Handovers';
import { uiActions } from 'careand-redux/slices/ui/ui';
import { useAppDispatch } from 'careand-redux/useAppDispatch';

const CPPTimelineHandover = ({ handover, patientId }) => {
  const dispatch = useAppDispatch();
  const [openModal, setOpenModal] = useState(false);
  const description = handover.patients?.find((info) => info.id === patientId)?.description;

  const onPin = () => {
    setOpenModal(false);
    dispatch(
      uiActions.addPinnedDocument({
        patientId,
        type: 'handover',
        id: handover.id,
        payload: { handover },
      }),
    );
  };

  return (
    <>
      {openModal ? (
        <HandoverModal handover={handover} onClose={() => setOpenModal(false)} onPin={onPin} />
      ) : null}
      <div className="item-wrapper clickable" data-tip onClick={() => setOpenModal(true)}>
        <div className="top-bar">
          <Icon src="user-group" />
          <span className="small-title">Handover</span>
        </div>
        <div className="item-content">
          <span>{description}</span>
        </div>
      </div>
    </>
  );
};

CPPTimelineHandover.propTypes = {
  handover: PropTypes.object.isRequired,
};

export default CPPTimelineHandover;
